<template>
  <el-table
    ref="table"
    stripe
    :data="data"
    :default-sort="defaultSort"
    @sort-change="$emit('sort-change', $event)"
    @selection-change="$emit('selection-change', $event)"
  >
    <template #empty>
      <span v-html="defaultEmptyText"></span>
    </template>
    <el-table-column type="selection" width="50" align="center" />
    <el-table-column prop="domain" sortable="custom">
      <template #default="{ row }">
        <a target="_blank" :href="`//${row.domain}`" rel="noopener noreferrer">{{ row.domain }}</a>
      </template>
      <template #header="{ column }">
        <el-tooltip :content="$t('c.table.columnTooltipDomain')" placement="top">
          <span>{{ $t('c.table.columnNameDomain') }}</span>
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column prop="impressions" sortable="custom">
      <template #default="{ row }">{{ row.impressions }}</template>
      <template #header="{ column }">
        <el-tooltip :content="$t('c.table.columnTooltipPlacementsImpressions')" placement="top">
          <span>{{ $t('c.table.columnNameImpressions') }}</span>
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column prop="ctr" sortable="custom">
      <template #default="{ row }">{{ row.ctr }}</template>
      <template #header="{ column }">
        <el-tooltip :content="$t('c.table.columnTooltipCTR')" placement="top">
          <span>{{ $t('c.table.columnNameCTR') }}</span>
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column prop="clicks" sortable="custom">
      <template #default="{ row }">{{ row.clicks }}</template>
      <template #header="{ column }">
        <el-tooltip :content="$t('c.table.columnTooltipPlacementsClicks')" placement="top">
          <span>{{ $t('c.table.columnNameClicks') }}</span>
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column prop="cpc" sortable="custom">
      <template #default="{ row }">{{ row.cpc }}</template>
      <template #header="{ column }">
        <el-tooltip :content="$t('c.table.columnTooltipCPC')" placement="top">
          <span>{{ $t('c.table.columnNameCPC') }}</span>
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column prop="conv_rate" sortable="custom">
      <template #default="{ row }">{{ row.convRate | toFixed(1) }}</template>
      <template #header="{ column }">
        <el-tooltip :content="$t('c.table.columnTooltipCR')" placement="top">
          <span>{{ $t('c.table.columnNameCR') }}</span>
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column prop="conversions" sortable="custom">
      <template #default="{ row }">{{ row.conversions }}</template>
      <template #header="{ column }">
        <el-tooltip :content="$t('c.table.columnTooltipConversions')" placement="top">
          <span>{{ $t('c.table.columnNameConversions') }}</span>
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column prop="cost" sortable="custom">
      <template #default="{ row }">{{ row.cost }}</template>
      <template #header="{ column }">
        <el-tooltip :content="$t('c.table.columnTooltipCost')" placement="top">
          <span>{{ $t('c.table.columnNameCost') }}</span>
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column prop="cost_conv" sortable="custom">
      <template #default="{ row }">{{ row.costConv }}</template>
      <template #header="{ column }">
        <v-cpl-tooltip :cpl="cpl" />
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import tableMixin from '@/mixins/table'
import VCplTooltip from '@/components/common/VCplTooltip.vue'


export default {
  name: 'VPlacementsTableBlackList',
  components: { VCplTooltip },

  mixins: [tableMixin],

  props: {
    data: {
      type: Array,
      required: true
    },
    defaultSort: {
      type: Object,
      required: true,
      validator(defaultSort) {
        const props = ['prop', 'order']
        const sortProps = Object.getOwnPropertyNames(defaultSort)

        return props.every(prop => sortProps.includes(prop))
      }
    },
    cpl: {
      type: [Object, Number]
    }
  }
}
</script>
